import React, { useEffect, useState } from "react";
import CustomMultipleFileUploader from "../../../../../banker/bidder/CustomMultipleFileUploader";
import { Button } from "../../../../../../shadcn/components/ui/button";
import { BetaForm as useBetaForm } from "@reusejs/react";
import { getBidderByUuid, updateBidderForEvent } from "services";

interface JBProofUploadComponentProps {
  stepsTitles: any;
  activeStep: any;
  setActiveStep: any;
  bidderUuid: any;
  init: any;
}
export default function JBProofUploadComponent({
  stepsTitles,
  activeStep,
  setActiveStep,
  bidderUuid,
  init,
}: JBProofUploadComponentProps) {
  const [kycFiles, setKycFiles] = useState<any>([]);
  const [renderKey, setRenderKey] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState<any>(null);
  const form = useBetaForm({
    proof_jb: "",
  });
  const form_constraints = {
    proof_jb: {
      presence: {
        allowEmpty: true,
      },
    },
  };
  useEffect(() => {
    form.setValidationRules(form_constraints);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.value]);

  const handleSubmit = async () => {
    if (form.validate()) {
      setLoadingText("Uploading Proof of Joint Participation...");
      setLoading(true);
      const data: any = await getBidderByUuid(bidderUuid);
      await updateBidderForEvent({
        uuid: bidderUuid,
        meta: {
          ...data?.meta,
          steps_status: {
            ...data?.meta?.steps_status,
            joint_proof: "completed",
          },
        },
        kyc_data: {
          ...data?.kyc_data,
          joint_proof: kycFiles[0] || null,
        },
        verification_step: "joint_proof",
      });
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setActiveStep(activeStep + 1);
      await init();
      setLoading(false);
    }
  };
  return (
    <div>
      <h4 className="font-bold text-lg font-openSans">
        {stepsTitles?.[activeStep]?.label}
      </h4>
      <div className="mt-4 min-h-[300px] max-w-xl">
        <div className="text-xs md:text-sm font-openSans text-brand-textGrey">
          Please upload a valid proof of joint participation document
        </div>
        <ul className="mt-2 list-disc list-inside text-sm text-gray-600 space-y-1">
          <li>
            The document must be jointly signed by all participating bidders,
            including the primary bidder.
          </li>
          <li>
            Ensure that all bidder names and signatures are clearly visible.
          </li>
          <li>
            Incomplete or unclear documents may delay the verification process.
          </li>
        </ul>
        <div className="mt-4 max-w-xl">
          <div className="mt-4">
            <CustomMultipleFileUploader
              key={renderKey}
              handleChange={(data: any) => {
                form.setField("proof_jb", data?.[0]?.id || "");
                // console.log("test3e4567890-", data);
                setKycFiles(data);
              }}
              allowedMimeTypes={["image/png", "image/jpeg"]}
              property_uuid={bidderUuid}
              owner_service_type="joint_bidder_proof"
              data={kycFiles}
              maxAllowed={1}
              defaultText="Please Upload Proof of Joint Participation"
            />
            {form.errors.get("proof_jb") ? (
              <p className="mt-1 text-sm text-red-500">
                {form.errors.get("proof_jb")[0]}
              </p>
            ) : null}
          </div>
          <div className="mt-8 flex">
            <Button
              disabled={loading}
              className="w-full max-w-xl h-10 text-[18px]"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
      {loading && <LoadingModal loadingText={loadingText} />}
    </div>
  );
}

interface LoadingModalProps {
  loadingText?: string;
}
const LoadingModal = ({ loadingText }: LoadingModalProps) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className=" text-white flex flex-col relative">
        <div className="flex flex-col flex-grow h-full">
          <div className="flex justify-center items-center">
            <div className="w-12 h-12 border-8 border-t-6 border-brand-orange rounded-full animate-spin bg-gradient-to-r from-brand-orange to-blue-100 shadow-lg"></div>
          </div>
          <div className="mt-2 text-sm font-openSans text-center">
            {loadingText || "Validating Details. Please wait..."}
          </div>
        </div>
      </div>
    </div>
  );
};
